<div class="row p-1 blue">
  <div class="col-12 pageTitle">
    <h2>&nbsp;&nbsp;&nbsp;Reset All Passwords</h2>
  </div>
</div>

<div class="card">
  <div class="p-fluid formgrid grid">
    <div class="field col-12 md:col-4">
      <span class="p-float-label">
        <input
          id="float-inpu1t"
          pInputText
          [(ngModel)]="lastName"
          type="text"
          class="textboxBorder-1"
        />
        <label for="float-input1" class="f1">Last Name:</label>
      </span>
    </div>

    <div class="field col-12 md:col-4">
      <span class="p-float-label PL-3">
        <input
          id="float-input1"
          pInputText
          [(ngModel)]="firstName"
          type="text"
          class="textboxBorder-1"
        />
        <label for="float-input" class="f1">First Name:</label>
      </span>
    </div>

    <span class="pt-1">
      &nbsp;
      <button
        pButton
        type="button"
        icon="pi pi-search"
        label="Search"
        (click)="getUserList(1)"
        class="ui-button-plain buttonWidth-8 ml-3"
      ></button>
      &nbsp;<button
        pButton
        label="Clear"
        severity="secondary"
        icon="pi pi-refresh"
        class="buttonWidth-8 fl ml-1 GreyButton"
        (click)="clearUserList()"
      ></button>
    </span>

    <!--<div class="field col-12 md:col-1 alignright mt-1 pl-5 mbl-0">
        <button pButton type="button" icon="pi pi-search" label="Search" (click)="getUserList(1)"
                class="p-button-plain buttonWidth-10 "></button>
    </div>
    <div class="field col-12 md:col-1 alignright mt-1 pl-8  mbl-0">
        <button pButton type="button" icon="pi pi-times-circle" label="Clear" (click)="clearUserList()"
                class="p-button-plain buttonWidth-10 fl GreyButton"></button>
    </div>-->
  </div>
</div>

<div class="field col-12 md:col-3 mb-2">
  <button
    pButton
    type="button"
    label="Reset Password"
    pTooltipPosition="true"
    icon="pi pi-replay"
    class="ui-button-plain buttonWidth-11 GreyButton"
    (click)="onDisplayResetPassword()"
  ></button>
</div>

<p-table
  *ngIf="users"
  [resetPageOnSort]="false"
  lazy="true"
  (onLazyLoad)="nextPage($event)"
  [totalRecords]="users.totalRecords"
  [currentPageReportTemplate]="'{currentPage} of {totalPages}'"
  [columns]="cols"
  [alwaysShowPaginator]="false"
  [rows]="rows"
  [paginator]="true"
  [value]="users.data"
  dataKey="userId"
  [(selection)]="selectedUsers"
  [(first)]="first"
>
  <ng-template pTemplate="header" let-columns>
    <tr>
      <th style="width: 2.3em">
        <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
      </th>
      <th *ngFor="let col of columns">
        {{ col.header }}
      </th>
      <th class="col-12 md:col-1" style="text-align: center !important">
        Active
      </th>
    </tr>
  </ng-template>
  <ng-template
    pTemplate="body"
    let-rowData
    let-columns="columns"
    let-index="index"
  >
    <tr>
      <td style="width: 2.3em">
        <p-tableCheckbox [value]="rowData"> </p-tableCheckbox>
      </td>
      <td *ngFor="let col of columns">
        {{ rowData[col.field] }}
      </td>

      <td style="text-align: center !important">
        <span *ngIf="rowData['active'] == true; else falsy">
          <button
            pButton
            pRipple
            icon="pi pi-check"
            class="p-button-rounded p-button-success"
          ></button>
        </span>
        <ng-template #falsy>
          <span>
            <button
              pButton
              pRipple
              icon="pi pi-times"
              class="p-button-rounded p-button-danger"
            ></button>
          </span>
        </ng-template>
      </td>
    </tr>
  </ng-template>
  <ng-template pTemplate="emptymessage">
    <tr>
      <td colspan="8">No Records found.</td>
    </tr>
  </ng-template>
</p-table>

<p-dialog
  [showHeader]="true"
  *ngIf="displayResetPassword"
  [(visible)]="displayResetPassword"
  modal="true"
  [draggable]="false"
  header="Reset Group Password"
  [style]="{ width: '50%', maxWidth: '500px', height: '400px' }"
>
  <form [formGroup]="resetPasswordForm">
    <div class="grid">
      <div class="col-12 mt-2">
        <span class="p-float-label">
          <input
            id="float-input1"
            style="width: 100%"
            type="password"
            pInputText
            appFormErrorMessages
            formControlName="newPassword"
            autocomplete="new-password"
          />
          <label for="password">Password</label>
        </span>
      </div>
      <div class="col-12 mt-2">
        <span class="p-float-label">
          <input
            id="float-input2"
            style="width: 100%"
            type="password"
            appFormErrorMessages
            pInputText
            formControlName="confirmPassword"
            autocomplete="off"
          />
          <label for="confirmPassword">Confirm New Password</label>
        </span>
      </div>
      <div
        class="col-12 p-messages p-messages-summary border-radius-5"
        *ngIf="ShowErrorSummary">
        <span style="font-size: 14px;color:red;">{{ errorValidationSummary }}</span>
      </div>
    </div>
  </form>
  <p-footer style="display: flex; justify-content: center">
    <button
      pButton
      type="submit"
      icon="pi pi-save"
      (click)="onResetPassword()"
      label="Save"
      class="p-button-plain"
    ></button>
    <button
      pButton
      type="button"
      icon="pi pi-times-circle"
      (click)="onCancel()"
      label="Cancel"
      class="p-button-plain"
    ></button>
  </p-footer>
</p-dialog>
